// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
.owl-carousel, .owl-carousel .owl-item {
	-webkit-tap-highlight-color: transparent;
	position: relative
}
.owl-carousel {
	display: none;
	width: 100%;
	z-index: 1
}
.owl-carousel .owl-stage {
	position: relative;
	touch-action: manipulation;
	-moz-backface-visibility: hidden
}
.owl-carousel .owl-stage:after {
	content: ".";
	display: block;
	clear: both;
	visibility: hidden;
	line-height: 0;
	height: 0
}
.owl-carousel .owl-stage-outer {
	position: relative;
	overflow: hidden;
	-webkit-transform: translate3d(0, 0, 0)
}
.owl-carousel .owl-item, .owl-carousel .owl-wrapper {
	-webkit-backface-visibility: hidden;
	-moz-backface-visibility: hidden;
	-ms-backface-visibility: hidden;
	-webkit-transform: translate3d(0, 0, 0);
	-moz-transform: translate3d(0, 0, 0);
	-ms-transform: translate3d(0, 0, 0)
}
.owl-carousel .owl-item {
	min-height: 1px;
	float: left;
	-webkit-backface-visibility: hidden;
	-webkit-touch-callout: none
}
.owl-carousel .owl-item img {
	display: block;
	width: 100%
}
.owl-carousel .owl-dots.disabled, .owl-carousel .owl-nav.disabled {
	display: none
}
.no-js .owl-carousel, .owl-carousel.owl-loaded {
	display: block
}
.owl-carousel .owl-dot, .owl-carousel .owl-nav .owl-next, .owl-carousel .owl-nav .owl-prev {
	cursor: pointer;
	-webkit-user-select: none;
	user-select: none
}
.owl-carousel .owl-nav button.owl-next, .owl-carousel .owl-nav button.owl-prev, .owl-carousel button.owl-dot {
	background: 0 0;
	color: inherit;
	border: none;
	padding: 0!important;
	font: inherit
}
.owl-carousel.owl-loading {
	opacity: 0;
	display: block
}
.owl-carousel.owl-hidden {
	opacity: 0
}
.owl-carousel.owl-refresh .owl-item {
	visibility: hidden
}
.owl-carousel.owl-drag .owl-item {
	touch-action: pan-y;
	-webkit-user-select: none;
	user-select: none
}
.owl-carousel.owl-grab {
	cursor: move;
	cursor: grab
}
.owl-carousel.owl-rtl {
	direction: rtl
}
.owl-carousel.owl-rtl .owl-item {
	float: right
}
.owl-carousel .animated {
	animation-duration: 1s;
	animation-fill-mode: both
}
.owl-carousel .owl-animated-in {
	z-index: 0
}
.owl-carousel .owl-animated-out {
	z-index: 1
}
.owl-carousel .fadeOut {
	animation-name: fadeOut
}
@keyframes fadeOut {
0% {
opacity:1
}
100% {
opacity:0
}
}
.owl-height {
	transition: height .5s ease-in-out
}
.owl-carousel .owl-item .owl-lazy {
	opacity: 0;
	transition: opacity .4s ease
}
.owl-carousel .owl-item .owl-lazy:not([src]), .owl-carousel .owl-item .owl-lazy[src^=""] {
	max-height: 0
}
.owl-carousel .owl-item img.owl-lazy {
	transform-style: preserve-3d
}
.owl-carousel .owl-video-wrapper {
	position: relative;
	height: 100%;
	background: #000
}
.owl-carousel .owl-video-play-icon {
	position: absolute;
	height: 80px;
	width: 80px;
	left: 50%;
	top: 50%;
	margin-left: -40px;
	margin-top: -40px;
	cursor: pointer;
	z-index: 1;
	-webkit-backface-visibility: hidden;
	transition: transform .1s ease
}
.owl-carousel .owl-video-play-icon:hover {
	transform: scale(1.3, 1.3)
}
.owl-carousel .owl-video-playing .owl-video-play-icon, .owl-carousel .owl-video-playing .owl-video-tn {
	display: none
}
.owl-carousel .owl-video-tn {
	opacity: 0;
	height: 100%;
	background-position: center center;
	background-repeat: no-repeat;
	background-size: contain;
	transition: opacity .4s ease
}
.owl-carousel .owl-video-frame {
	position: relative;
	z-index: 1;
	height: 100%;
	width: 100%
}
`, "",{"version":3,"sources":["webpack://./src/composant/css/owl.carousel.min.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;CACC,wCAAwC;CACxC;AACD;AACA;CACC,aAAa;CACb,WAAW;CACX;AACD;AACA;CACC,kBAAkB;CAElB,0BAA0B;CAC1B;AACD;AACA;CACC,YAAY;CACZ,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,cAAc;CACd;AACD;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB;AACD;AACA;CACC,mCAAmC;CACnC,gCAAgC;CAChC,+BAA+B;CAC/B,uCAAuC;CACvC,oCAAoC;CACpC;AACD;AACA;CACC,eAAe;CACf,WAAW;CACX,mCAAmC;CACnC;AACD;AACA;CACC,cAAc;CACd;AACD;AACA;CACC;AACD;AACA;CACC;AACD;AACA;CACC,eAAe;CACf,yBAAyB;CAIzB;AACD;AACA;CACC,eAAe;CACf,cAAc;CACd,YAAY;CACZ,oBAAoB;CACpB;AACD;AACA;CACC,UAAU;CACV;AACD;AACA;CACC;AACD;AACA;CACC;AACD;AACA;CAEC,mBAAmB;CACnB,yBAAyB;CAGzB;AACD;AACA;CACC,YAAY;CACZ;AACD;AACA;CACC;AACD;AACA;CACC;AACD;AACA;CACC,sBAAsB;CACtB;AACD;AACA;CACC;AACD;AACA;CACC;AACD;AACA;CACC;AACD;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;CACC;AACD;AACA;CACC,UAAU;CACV;AACD;AACA;CACC;AACD;AACA;CACC;AACD;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ;AACD;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,iBAAiB;CACjB,eAAe;CACf,UAAU;CACV,mCAAmC;CACnC;AACD;AACA;CAEC;AACD;AACA;CACC;AACD;AACA;CACC,UAAU;CACV,YAAY;CACZ,kCAAkC;CAClC,4BAA4B;CAC5B,wBAAwB;CACxB;AACD;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ;AACD","sourcesContent":["/**\r\n * Owl Carousel v2.3.4\r\n * Copyright 2013-2018 David Deutsch\r\n * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE\r\n */\r\n.owl-carousel, .owl-carousel .owl-item {\r\n\t-webkit-tap-highlight-color: transparent;\r\n\tposition: relative\r\n}\r\n.owl-carousel {\r\n\tdisplay: none;\r\n\twidth: 100%;\r\n\tz-index: 1\r\n}\r\n.owl-carousel .owl-stage {\r\n\tposition: relative;\r\n\t-ms-touch-action: pan-Y;\r\n\ttouch-action: manipulation;\r\n\t-moz-backface-visibility: hidden\r\n}\r\n.owl-carousel .owl-stage:after {\r\n\tcontent: \".\";\r\n\tdisplay: block;\r\n\tclear: both;\r\n\tvisibility: hidden;\r\n\tline-height: 0;\r\n\theight: 0\r\n}\r\n.owl-carousel .owl-stage-outer {\r\n\tposition: relative;\r\n\toverflow: hidden;\r\n\t-webkit-transform: translate3d(0, 0, 0)\r\n}\r\n.owl-carousel .owl-item, .owl-carousel .owl-wrapper {\r\n\t-webkit-backface-visibility: hidden;\r\n\t-moz-backface-visibility: hidden;\r\n\t-ms-backface-visibility: hidden;\r\n\t-webkit-transform: translate3d(0, 0, 0);\r\n\t-moz-transform: translate3d(0, 0, 0);\r\n\t-ms-transform: translate3d(0, 0, 0)\r\n}\r\n.owl-carousel .owl-item {\r\n\tmin-height: 1px;\r\n\tfloat: left;\r\n\t-webkit-backface-visibility: hidden;\r\n\t-webkit-touch-callout: none\r\n}\r\n.owl-carousel .owl-item img {\r\n\tdisplay: block;\r\n\twidth: 100%\r\n}\r\n.owl-carousel .owl-dots.disabled, .owl-carousel .owl-nav.disabled {\r\n\tdisplay: none\r\n}\r\n.no-js .owl-carousel, .owl-carousel.owl-loaded {\r\n\tdisplay: block\r\n}\r\n.owl-carousel .owl-dot, .owl-carousel .owl-nav .owl-next, .owl-carousel .owl-nav .owl-prev {\r\n\tcursor: pointer;\r\n\t-webkit-user-select: none;\r\n\t-khtml-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none\r\n}\r\n.owl-carousel .owl-nav button.owl-next, .owl-carousel .owl-nav button.owl-prev, .owl-carousel button.owl-dot {\r\n\tbackground: 0 0;\r\n\tcolor: inherit;\r\n\tborder: none;\r\n\tpadding: 0!important;\r\n\tfont: inherit\r\n}\r\n.owl-carousel.owl-loading {\r\n\topacity: 0;\r\n\tdisplay: block\r\n}\r\n.owl-carousel.owl-hidden {\r\n\topacity: 0\r\n}\r\n.owl-carousel.owl-refresh .owl-item {\r\n\tvisibility: hidden\r\n}\r\n.owl-carousel.owl-drag .owl-item {\r\n\t-ms-touch-action: pan-y;\r\n\ttouch-action: pan-y;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none\r\n}\r\n.owl-carousel.owl-grab {\r\n\tcursor: move;\r\n\tcursor: grab\r\n}\r\n.owl-carousel.owl-rtl {\r\n\tdirection: rtl\r\n}\r\n.owl-carousel.owl-rtl .owl-item {\r\n\tfloat: right\r\n}\r\n.owl-carousel .animated {\r\n\tanimation-duration: 1s;\r\n\tanimation-fill-mode: both\r\n}\r\n.owl-carousel .owl-animated-in {\r\n\tz-index: 0\r\n}\r\n.owl-carousel .owl-animated-out {\r\n\tz-index: 1\r\n}\r\n.owl-carousel .fadeOut {\r\n\tanimation-name: fadeOut\r\n}\r\n@keyframes fadeOut {\r\n0% {\r\nopacity:1\r\n}\r\n100% {\r\nopacity:0\r\n}\r\n}\r\n.owl-height {\r\n\ttransition: height .5s ease-in-out\r\n}\r\n.owl-carousel .owl-item .owl-lazy {\r\n\topacity: 0;\r\n\ttransition: opacity .4s ease\r\n}\r\n.owl-carousel .owl-item .owl-lazy:not([src]), .owl-carousel .owl-item .owl-lazy[src^=\"\"] {\r\n\tmax-height: 0\r\n}\r\n.owl-carousel .owl-item img.owl-lazy {\r\n\ttransform-style: preserve-3d\r\n}\r\n.owl-carousel .owl-video-wrapper {\r\n\tposition: relative;\r\n\theight: 100%;\r\n\tbackground: #000\r\n}\r\n.owl-carousel .owl-video-play-icon {\r\n\tposition: absolute;\r\n\theight: 80px;\r\n\twidth: 80px;\r\n\tleft: 50%;\r\n\ttop: 50%;\r\n\tmargin-left: -40px;\r\n\tmargin-top: -40px;\r\n\tcursor: pointer;\r\n\tz-index: 1;\r\n\t-webkit-backface-visibility: hidden;\r\n\ttransition: transform .1s ease\r\n}\r\n.owl-carousel .owl-video-play-icon:hover {\r\n\t-ms-transform: scale(1.3, 1.3);\r\n\ttransform: scale(1.3, 1.3)\r\n}\r\n.owl-carousel .owl-video-playing .owl-video-play-icon, .owl-carousel .owl-video-playing .owl-video-tn {\r\n\tdisplay: none\r\n}\r\n.owl-carousel .owl-video-tn {\r\n\topacity: 0;\r\n\theight: 100%;\r\n\tbackground-position: center center;\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-size: contain;\r\n\ttransition: opacity .4s ease\r\n}\r\n.owl-carousel .owl-video-frame {\r\n\tposition: relative;\r\n\tz-index: 1;\r\n\theight: 100%;\r\n\twidth: 100%\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
